import React, { useState, useEffect } from "react";
import { MDBRow, MDBCol, MDBInput, MDBBtn, MDBContainer } from "mdbreact";

import Axios from "axios";

import "react-datepicker/dist/react-datepicker.css";

import WarningBox from "../components/WarningBox";

import { toast, ToastContainer } from "mdbreact";
import Select from "react-select";
const AddEditVehicle = (props) => {
  const useMountEffect = (functionName) => useEffect(functionName, []);
  const serverURL = props.apiServer;

  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };
  const [frm, setValues] = useState({
    code: "new",
    make: { value: "0", label: "[No Brand]" },
    yearmodel: new Date().getUTCFullYear(),
    plateno: "",
    conductionsticker: "",
    fueltype: { value: "1", label: "GASOLINE" },
    mileage: "0",
    chassisno: "",
    engineno: "",
    variant: "",
    deleted: false,
    datecreated: new Date(),
    usertoken: sessionStorage.getItem("msal.uc"),
  });

  const [makeoptions, setmakeoptions] = useState([]);
  const loadmakeoption = () => {
    Axios.get(serverURL + "/getmakeoptions", bearer)
      .then((res) => {
        setmakeoptions(res.data);
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const [fueltypeoptions, setfueltypeoptions] = useState([]);
  const loadfueltypeoption = () => {
    Axios.get(serverURL + "/getfueltypeoptions", bearer)
      .then((res) => {
        setfueltypeoptions(res.data);
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };
  const updateField = (e) => {
    const target = e.target;

    let value = target.value;
    let name = target.id;

    if (target.type === "checkbox") {
      value = target.checked;

      setValues({ ...frm, [name]: value });
    } else {
      setValues({ ...frm, [name]: value });
    }
  };

  const handleChange = (objName) => (selOption) => {
    setValues({ ...frm, [objName]: selOption });
  };

  function submitHandler(event) {
    event.preventDefault();
    event.target.className += " was-validated";

    savevehicle();
  }

  const [errorMessage, setErrorMessage] = useState("");

  const [modalWarning, showWarningBox] = useState(false);

  const toggleWarningBox = () => {
    showWarningBox(!modalWarning);
  };

  const loadvehicledetails = () => {
    Axios.get(
      props.apiServer + "/loadvehicledetails?acode=" + props.code,
      bearer
    )
      .then((res) => {
        if (res.data !== "empty") {
          setValues({
            ...frm,
            code: props.code,

            make: { value: res.data.carmakecode, label: res.data.carmake },
            yearmodel: res.data.yearmodel,
            plateno: res.data.plateno,
            conductionsticker: res.data.conductionsticker,
            fueltype: {
              value: res.data.fueltypecode,
              label: res.data.fueltype,
            },
            mileage: res.data.mileage,
            chassisno: res.data.chassisno,
            engineno: res.data.engineno,
            variant: res.data.variant,
            deleted: res.data.deleted,
          });
        } else {
          console.log("No record");
        }
      })

      .catch((error) => {
        setErrorMessage(error);
        // toggleWarningBox();
        console.log(error);
      });
  };

  const savevehicle = () => {
    const data = frm;

    Axios.post(props.apiServer + "/savevehicle", data, bearer)
      .then((res) => {
        if (res.data.status === "1") {
          setValues({ ...frm, code: res.data.code });

          toast.info(res.data.message, {
            closeButton: false,
          });
          if (props.quicktool === "yes") {
            props.toggleModal();
          } else if (props.quickadd === "yes") {
            props.toggleModal2();
          } else {
            props.refreshGrid();
          }
        } else {
          setErrorMessage(res.data.message);
          toggleWarningBox();
        }
      })
      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };
  useMountEffect(loadmakeoption);
  useMountEffect(loadfueltypeoption);
  useMountEffect(loadvehicledetails);

  return (
    <React.Fragment>
      <MDBContainer fluid>
        <MDBRow>
          <MDBCol md="10">
            <form
              className="needs-validation"
              onSubmit={submitHandler}
              noValidate
            >
              <MDBRow hidden>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.code}
                    id="code"
                    label="code"
                    required
                    onChange={updateField}
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>

              <MDBRow>
                <MDBCol md="10" className="text-left">
                  <label className="grey-text">
                    <small>&nbsp;Make</small>
                  </label>
                  <br />
                  <Select
                    placeholderText="Make"
                    isSearchable
                    value={frm.make}
                    onChange={handleChange("make")}
                    options={makeoptions}
                    required
                  />

                  <div className="invalid-feedback">
                    This field is required!
                  </div>
                  <div className="valid-feedback">Looks good!</div>

                  <br />
                </MDBCol>

                {/* <MDBCol md="2" className="ml-0 pt-4">
                  <MDBBtn
                    size="sm"
                    onClick={toggleVehicleOption}
                    className="grey lighten-5 brown-text"
                  >
                    <MDBIcon icon="plus" />
                  </MDBBtn>
                </MDBCol> */}
              </MDBRow>

              <MDBRow>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.variant}
                    id="variant"
                    label="Variant"
                    required
                    onChange={updateField}
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.yearmodel}
                    id="yearmodel"
                    label="Year Model"
                    required
                    type="number"
                    onChange={updateField}
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>

              <MDBRow>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.conductionsticker}
                    id="conductionsticker"
                    label="Conduction Sticker"
                    onChange={updateField}
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>

              <MDBRow>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.plateno}
                    id="plateno"
                    label="Plate Number"
                    onChange={updateField}
                  ></MDBInput>
                </MDBCol>
              </MDBRow>

              <MDBRow>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.chassisno}
                    id="chassisno"
                    label="Chassis No"
                    onChange={updateField}
                  ></MDBInput>
                </MDBCol>
              </MDBRow>

              <MDBRow>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.engineno}
                    id="engineno"
                    label="Engine No"
                    onChange={updateField}
                  ></MDBInput>
                </MDBCol>
              </MDBRow>

              <MDBRow>
                <MDBCol md="10" className="text-left">
                  <label className="grey-text">
                    <small>&nbsp;Fuel Type</small>
                  </label>
                  <br />
                  <Select
                    placeholderText="Fuel Type"
                    isSearchable
                    value={frm.fueltype}
                    onChange={handleChange("fueltype")}
                    options={fueltypeoptions}
                    required
                  />
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.mileage}
                    id="mileage"
                    label="Mileage (KM)"
                    onChange={updateField}
                    type="number"
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol md="10">
                  <MDBInput
                    id="deleted"
                    label="Is Deleted"
                    type="checkbox"
                    checked={frm.deleted}
                    onChange={updateField}
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol md="12">
                  <MDBBtn className="blue lighten-1" type="submit">
                    Save
                  </MDBBtn>
                  {props.quicktool === "yes" ? (
                    <>
                      <MDBBtn
                        id="cmdClose"
                        className="blue lighten-4 blue-text"
                        onClick={props.toggleModal}
                      >
                        Close this
                      </MDBBtn>
                      <MDBBtn
                        id="cmdClose"
                        className="orange lighten-4 black-text"
                        onClick={props.toggleModal2}
                      >
                        Back to Customer Ticket
                      </MDBBtn>
                    </>
                  ) : (
                    ""
                  )}
                  {props.quickadd === "yes" ? (
                    <>
                      <MDBBtn
                        id="cmdClose"
                        className="blue lighten-4 blue-text"
                        onClick={props.toggleModal2}
                      >
                        Close this
                      </MDBBtn>
                    </>
                  ) : (
                    ""
                  )}

                  {/* {props.code === "" ? (
                    <MDBBtn
                      id="cmdClose"
                      className="blue lighten-4 blue-text"
                      onClick={props.toggleModal}
                    >
                      Close
                    </MDBBtn>
                  ) : (
                    ""
                  )} */}
                </MDBCol>
                <MDBCol md="6"></MDBCol>
              </MDBRow>
            </form>
          </MDBCol>
        </MDBRow>
      </MDBContainer>

      <ToastContainer
        hideProgressBar={true}
        newestOnTop={true}
        autoClose={5000}
      />

      <WarningBox
        errorMessage={errorMessage}
        isOpen={modalWarning}
        toggleModal={toggleWarningBox}
      />
      {/* <MessagePersonalInfo /> */}
    </React.Fragment>
  );
};
export default AddEditVehicle;
